const lang = {
	relation: {
		title: '現在、%{shop} と PingPong Checkout を連携しています',
		logged: '以下のログイン済みアカウントで続行してもよろしいですか？',
		login: '先に PingPong Checkout アカウントにログインしてください',
		continue: '続行',
		changeAccount: '別のアカウントに切り替える'
	},
	selectWebsite: {
		tipTitle: '%{shop} への認証に使用するウェブサイトを選択してください',
		tipSubtitle: '利用可能なウェブサイトを絞り込んで表示しています',
		otherTipNo1: '%{shop} に次の情報の閲覧を許可します:',
		otherTipNo2: '・PingPong Checkout の本人確認情報（会社情報、法人情報、登録者情報などを含みますが、これらに限定されません）',
		otherTipNo3: '・PingPong Checkout のウェブサイト情報（Acc ID、URL、サイトステータスなどを含みますが、これらに限定されません）',
		howToApplyHalf1: '「同意して認証」をクリックすると、%{shop} とお客様情報を共有することに同意したものとみなされます。この情報の利用は',
		shopifyRule: '%{shop} の「プライバシーポリシー」',
		pingPongRule: 'PingPong の「プライバシーポリシー」',
		symbolAnd: 'および',
		sureButton: '同意して認証',
		cancelButton: 'キャンセル',
		noTokenTip: '%{shop} からの認証を取得していません。認証取得後に再度お試しください。',
		userWantsThisUrl: 'URL：',
		userWantsThisAccId: 'Acc ID：',
		accIdBinded: 'すでに %{shop} アカウントに紐付けられています。紐付けを変更してもよろしいですか？変更後、他の取引（返金など）を行う場合は、PingPong Checkout 管理画面にログインして操作してください。',
		webBinded: '現在の %{shop} アカウントはすでに別のウェブサイトに紐付けられています。紐付けを変更してもよろしいですか？変更後、他の取引（返金など）を行う場合は、PingPong Checkout 管理画面にログインして操作してください。',
		accIdGatewayBinded: 'すでに %{shop} アカウントに紐付けられています。紐付けを変更してもよろしいですか？',
		webGatewayBinded: '現在の %{shop} アカウントはすでに別のウェブサイトに紐付けられています。紐付けを変更してもよろしいですか？',
		loadingTip: '処理中...',
		attention: 'ご注意'
	},
	hasNone: {
		tips: 'このアカウントにはまだサイトが追加されていません。先に PingPong Checkout 管理画面でウェブサイト情報を登録してから、再度認証してください。',
		sureButton: 'Webサイト追加',
		cancelButton: 'キャンセル'
	},
	loading: {
		doing: '認証中...',
		success: '認証に成功しました',
		successTip1: 'まもなく PingPong Checkout を離れます...',
		successTip2: '自動で遷移しない場合はこちらをクリックしてください',
		failed: '認証に失敗しました',
		failedTip1: 'ネットワークエラーが発生しました',
		failedTip2: '再試行'
	},
	selectRegion: {
		tipSubtitle: '事業主体の所在地域を選択してください',
		tip: '事業主体が米国以外の場合は、米国地域を選択しないでください。',
		sureButton: '確認',
		cancelButton: 'キャンセル',
		placeholder: '地域を選択してください',
		otherRigion: 'その他の地域',
		usRegion: '米国地域'
	}
}

export default lang
